import './index.css';
const notDigitsOrPlusRegExp = /[\D+]/g;
const prohibitedSymbolsRegExp = /[^0-9+()-]/g;
const digitRegexp = /\d/;
const notSpaceRegExp = /[^\s]/;
const buildRegExpFromNumber = (number, inTheMiddle = false, optionalDigits = true) => {
    const regExp = number
        .split('')
        .reduce((acc, char, index) => {
        // символы из строки нужно экранировать т.к. там могут оказаться символы имеющие специальное
        // значение в регулярных выражениях, например +
        acc.push(`\\u{${char.charCodeAt(0).toString(16)}}${optionalDigits ? '?' : ''}`);
        if (index !== number.length - 1) {
            acc.push('\\s?-?\\(?\\)?\\s?');
        }
        return acc;
    }, [])
        .join('');
    return new RegExp(inTheMiddle ? `.*(${regExp}).*` : regExp, 'u');
};
const phoneFormatterFactory = (params) => {
    const { setCountry, currentCountryRef, libPhoneNumberAPI: { formatIncompletePhoneNumber, parsePhoneNumber, getCountryCallingCode }, } = params;
    return (prevValue, value, caretPosition) => {
        let sanitizedValue = value.replace(prohibitedSymbolsRegExp, '');
        let formattedValue = sanitizedValue;
        let caret = caretPosition;
        let digitsBeforeCaret = value.substring(0, caret).replace(notDigitsOrPlusRegExp, '');
        // удалили один символ и этот символ не цифра, надо удалить ближайшую цифру слева от каретки
        if (prevValue.length - value.length === 1 && notDigitsOrPlusRegExp.test(prevValue[caretPosition])) {
            digitsBeforeCaret = digitsBeforeCaret.slice(0, -1);
            formattedValue = `${digitsBeforeCaret}${value.substring(caret)}`;
        }
        try {
            const phoneNumber = parsePhoneNumber(formattedValue, currentCountryRef.current || 'RU');
            formattedValue = phoneNumber.isValid()
                ? phoneNumber.format('NATIONAL', { nationalPrefix: false })
                : formatIncompletePhoneNumber(phoneNumber.nationalNumber, phoneNumber.country || currentCountryRef.current || 'RU');
            if (phoneNumber.country) {
                const code = getCountryCallingCode(phoneNumber.country);
                if (sanitizedValue.startsWith(`+${code}`)) {
                    sanitizedValue = sanitizedValue.slice(code.length + 1);
                }
                if (phoneNumber.country !== currentCountryRef.current) {
                    setCountry(phoneNumber.country);
                }
            }
        }
        catch {
            // do nothing
        }
        // В процессе форматирования libphonenumber может дописать в national number префикс, который не используется
        // в международном номере (для Беларуси например 80), при этом требование дизайна в остальном форматировать
        // часть номера после кода по национальным стандартам. Поэтому находим цифры которые пользователь не вводил
        // и удаляем их.
        const currentValueRegExp = buildRegExpFromNumber(sanitizedValue, true, false);
        formattedValue = formattedValue.match(currentValueRegExp)?.[1] || formattedValue;
        if (digitsBeforeCaret.length === 0) {
            caret = formattedValue.substring(0, caret).match(notSpaceRegExp)?.[0].length || 0;
        }
        else {
            // в результате форматирования в строке с номером могут появляться дополнительные символы
            // при этом каретка должна сохранить свое положение относительно цифр в номере
            // для этого находим позицию каретки в строке до форматирования, извлекаем из неё только цифры находящиеся
            // перед кареткой, находим длину строки после форматирования которая содержит те же цифры что и в строке до
            // форматирования перед кареткой и сдвигаем каретку на эту длину
            // для этого используем регулярку в которую добавляем все символы перед кареткой и возможные символы между
            // ними которые могут появиться после форматирования
            // кроме того делаем все символы опциональными, т.к. после форматирования может удалиться часть
            // символов в начале номера относящаяся к коду страны
            const caretPositionRegExp = buildRegExpFromNumber(digitsBeforeCaret);
            // применяем регулярку к отформатированной строке и сдвигаем каретку на длину найденного совпадения
            const match = formattedValue.match(caretPositionRegExp)?.[0];
            if (match) {
                const positionOfFirstDigitToTheRightOfCaret = formattedValue
                    .substring(match.length)
                    .search(digitRegexp);
                caret =
                    positionOfFirstDigitToTheRightOfCaret === -1
                        ? formattedValue.length
                        : positionOfFirstDigitToTheRightOfCaret + match.length;
            }
        }
        return {
            formattedValue,
            outputValue: formattedValue,
            caretPosition: caret,
        };
    };
};

export { phoneFormatterFactory };
//# sourceMappingURL=phoneFormatter.js.map
